/**
 * Defaults para Layout (Expansión, Stepper, Timeline, etc.)
 */

export const layoutDefaults: Record<string, Record<string, unknown> | undefined> = {
  VExpansionPanels: {
    variant: 'accordion',
    rounded: 'lg',
  },

  VExpansionPanel: {
    elevation: 0,
  },

  VStepper: {
    elevation: 2,
    rounded: 'lg',
    VBtn: {
      variant: 'elevated',
      rounded: 'lg',
    },
  },

  VTimeline: {
    density: 'comfortable',
    dotColor: 'primary',
  },

  VAvatar: {
    rounded: 'circle',
  },

  VImg: {
    rounded: 'lg',
  },

  VOverlay: {
    scrim: 'black',
    opacity: 0.6,
  },

  VDivider: {
    thickness: 1,
  },
}
